export const environment = {
    production: true,
    firebase: {
    apiKey: "AIzaSyAzzySPuL7Br5pwlpzMAbq4QHjvtI_A5gY",
    authDomain: "bwi-1266.firebaseapp.com",
    projectId: "bwi-1266",
    databaseURL: "https://bwi-1266.firebaseio.com",
    storageBucket: "bwi-1266.appspot.com",
    messagingSenderId: "866281120161",
    appId: "1:866281120161:web:5e611835c5ba4015e72be0",
    measurementId: "G-SDKD99BTJX",
    },
    shopProductsLimit: 50,
    timeToUpdateAgentLocation: 30000,
    deliveryBikeurl: 'assets/img/delivery-bike.png',
    destinationMarkerUrl: 'assets/img/map-marker.png',
    razorpay: {
      description: "Fish-E-Day Payment",
      currency: 'INR',
      image: 'https://fish-e-day.com/assets/img/admin-pic.png',
      theme: {
        color: '#f8491e'
      },
      useCheckoutJs: false
    },
    paytm: {
      CHANNEL_ID: 'WAP',
      WEBSITE: 'DEFAULT',
      INDUSTRY_TYPE_ID: 'Retail',
      ENVIRONMENT: 'production'
    },
    envPaytmActive: false,
    storeName: "Fish-E-Day",
    supportPhone: '1234567890',
    scrollLimit:20,
    priceReqFeature:false,
    appSharingImg:'https://fish-e-day.com/assets/img/admin-pic.png',
    deliveryFeature: false,
    ALGOLIA_APP_ID: 'DEYL6OZL2B',
    ALGOLIA_APP_KEY: 'd7f75c2a6d20c84da946c70a08039dbc',
    isDeliveryBasedKm: false,
    orderIdPrefix: 'ORD',
    defaultCountryCode: '+91',
    currencyCode: 'INR',
    taxType: 'GST',
    socialSigin: false,
    defaultProductView: 'list',
    webClientId:'866281120161-6kdi1vjbqp81ijlgtmpkqvqhrvbgn2ni.apps.googleusercontent.com',
    productSharing: true,
    phoneLength: 10,
    showFooterLogo: true,
    openAlgoliaSearch:false,
    LOGGLY_API_KEY: 'dd80a702-e3cf-4633-9d38-5ee92fe68193',
    priceForRetail: false,
    referralFeature: false,
    subscriptionFeature: false,
    RFQFeature: false,
    usersScrollLimit: 20,
    limitedTimeDeal: false,
    productRatings: false,
    multiRegion: false,
    multiVendor: false,
    membership: false,
    isDeliveryBasedOnWeight: false,
    userSignature: false,
    freeTrial: false,
    isBwiClient: false,
    lockSystem: false,
    broadcastLimit:24,
    imagesLimit: 5,
    orderUploadedDocImgsLimit: 5,
    resellingFeature: false,
    shareCatalogue: false,
    qtyLeft: 5,
    allOrderStatuses: ['Pending', 'Rejected', 'Confirmed', 'Cancelled', 'Dispatched', 'Delivered', 'Returned'],
    appAccessOnApproval: false,
    pickDrop: false,
    cashfree: {production: false},
    appointmentFeature: false
  };
